import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import config from '../config.js';
import UserContext from '../components/common/UserContext.js';
import {useSupportContext} from "../components/common/SupportContext";

// css
import '../assets/css/RequestLicense.css';
import '../assets/css/SecurityUpdates.css';

// components
import Spinner from '../components/common/Spinner.js';
import SoftwareGrid from '../components/SecurityUpdate/SoftwareGrid.js'
import PageHeader from '../components/common/PageHeader.js';
import SearchField from '../components/SecurityUpdate/SearchField.js';

// multilingual
import {Text} from '../components/common/MultilingualText.js';
import {mainMessages, securityUpdatesKey} from '../assets/text/MultilingualText.js';


export default function SecurityUpdate(props) {
    const {
        accessToken,
        siteLanguageDefault
    } = useContext(UserContext);
    const { dispatch } = useSupportContext();
    const [isLoading, setIsLoading] = useState(true);
    const [query, setQuery] = useState("");
    const [submit, handleSubmit] = useState("");
    const [updates, setUpdates] = useState([]);

    useEffect(() => {
        async function getSoftwareUpdates() {
            // set support metadata for search terms
            dispatch({
                type: 'UPDATE_TRANSACTION',
                payload: {
                    search_term: submit
                }
            })
            let headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            };

            setIsLoading(true);
            let url = (query === "") ? `${config.software_updates.SOFTWARE_SERVICE}?module=sc-update` : `${config.software_updates.SOFTWARE_SERVICE}?module=sc-update&filter=${query.trim()}`
            axios.get(
                url,
                {headers: headers}
            )
                .then((response) => {
                    if (response.status === 200) {
                        let data = response.data || [];
                        let family_tree = {};
                        data.forEach((item, index) => {
                            family_tree[item.PRODUCT_FAMILY] = (family_tree.hasOwnProperty(item.PRODUCT_FAMILY)) ? [...family_tree[item.PRODUCT_FAMILY], {...item}] : [{...item}];
                        });

                        let combined = [];

                        for (const [key, value] of Object.entries(family_tree)) {
                            if (key !== null) {
                                let details = []
                                value.forEach(update => {
                                    details.push({
                                        "SoftwareFamily": key,
                                        "Update": {
                                            "text": update['DESCRIPTION'],
                                            "link": `/security-updates-detail/${update['UPDATE_PUBLIC_ID']}`
                                        },
                                        "ReleaseDate": new Date(update['ORIGINAL_RELEASE_DATE'].replace(/-/g, "/")),
                                        "ReleaseDescription": update['RELEASE_DESCRIPTION'],
                                        "EligibilityDate": new Date(update['ELIGIBILITY_DATE'].replace(/-/g, "/")),
                                        "Version": update['RELEASE_VERSION'],
                                        "AffectedVersion": update['AFFECTED_VERSION'],
                                        "Criticality": update['CRITICALITY'],
                                    })
                                });
                                combined.push({product_family: key, details: details, expanded: false});
                            }
                        }

                        setUpdates(combined);
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    console.log("ERROR: Failed to GET Software Family data", error);
                    setIsLoading(false);
                });
        }

        getSoftwareUpdates();
    }, [submit]); // eslint-disable-line react-hooks/exhaustive-deps

    // Support Context Metadata
    // Set Module and Step values on page load
    useEffect(() => {
        dispatch({ type: 'MODULE_LOAD', payload: {module: 'Security Updates', step: ''}});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {isLoading ? <Spinner/> : <></>}
            <PageHeader/>
            <div className={"ksm-page-container"}>
                <div className={"k-h3"}>
                    <Text
                        textkey={securityUpdatesKey}
                        textdefault={mainMessages[siteLanguageDefault][securityUpdatesKey]}
                    />
                </div>
                <SearchField
                    query={query}
                    setQuery={setQuery}
                    handleSubmit={handleSubmit}
                />
                {(!isLoading) && <SoftwareGrid updates={updates} setUpdates={setUpdates}/>}
                <br/>
            </div>
        </>
    );
}
